define('helperUser-getMultipleChoiceSelectedOptionsCount',[],function() {
    'use strict';

    var getMultipleChoiceSelectedOptionsCount = function getMultipleChoiceSelectedOptionsCount(answers) {
        var count = 0;
        if ( answers && answers.length ) {

            answers.forEach(function(element) {
                var id = element.id(),
                    el = document.getElementById(id);

                if ( el && el.checked ) {
                    // el = document.getElementById(id + '-free-text');
                    // if (el) {
                    //     var val = $.trim( el.value );
                    //     if ( val ) {
                    //         count += 1;
                    //     }
                    // } else {
                    //     count += 1;
                    // }
                    count += 1;
                }
            });
        }
        return count;
    };

    return getMultipleChoiceSelectedOptionsCount;
});

